var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsApp2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#whats-app-2_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.281 14.446C59.198 8.358 51.11 5.004 42.491 5 24.73 5 10.277 19.448 10.27 37.207a32.15 32.15 0 004.3 16.103L10 70l17.08-4.479a32.197 32.197 0 0015.396 3.921h.014c17.757 0 32.212-14.45 32.22-32.209.003-8.606-3.346-16.7-9.428-22.787zm-22.79 49.556h-.011a26.747 26.747 0 01-13.63-3.732l-.979-.58-10.135 2.658 2.706-9.879-.638-1.013A26.7 26.7 0 0115.71 37.21C15.716 22.45 27.73 10.44 42.5 10.44c7.154.003 13.877 2.791 18.933 7.851 5.056 5.06 7.839 11.787 7.836 18.94-.006 14.761-12.019 26.771-26.779 26.771z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.48 68.148l4.361-15.927a30.678 30.678 0 01-4.104-15.367c.007-16.947 13.8-30.735 30.746-30.735 8.226.003 15.946 3.204 21.75 9.014 5.805 5.81 9 13.532 8.997 21.745-.007 16.948-13.8 30.737-30.745 30.737-.002 0 0 0 0 0h-.014a30.739 30.739 0 01-14.692-3.74l-16.3 4.273z",
    fill: "url(#whats-app-2_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.529 23.534c-.597-1.325-1.224-1.352-1.791-1.375-.464-.02-.995-.019-1.525-.019-.53 0-1.393.2-2.122.996-.73.796-2.786 2.721-2.786 6.637 0 3.915 2.852 7.699 3.25 8.23.398.53 5.505 8.822 13.594 12.012 6.722 2.651 8.09 2.124 9.55 1.991 1.459-.133 4.708-1.925 5.371-3.783.663-1.858.663-3.45.464-3.783-.199-.332-.73-.53-1.525-.929-.796-.398-4.708-2.323-5.438-2.589-.73-.265-1.26-.398-1.79.4-.531.795-2.056 2.587-2.52 3.118-.464.532-.928.598-1.724.2-.796-.4-3.36-1.239-6.4-3.95-2.366-2.109-3.963-4.714-4.427-5.51-.465-.797-.05-1.228.35-1.624.356-.357.795-.93 1.193-1.394.397-.465.53-.796.795-1.327.265-.532.133-.996-.066-1.394-.2-.398-1.746-4.334-2.453-5.907z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.018 14.343c-6.013-6.017-14.01-9.333-22.53-9.337-17.555 0-31.842 14.282-31.85 31.837a31.78 31.78 0 004.252 15.918L10.37 69.26l16.884-4.428a31.829 31.829 0 0015.22 3.876h.014c17.553 0 31.842-14.285 31.85-31.839.002-8.508-3.308-16.507-9.32-22.526zm-22.53 48.988h-.01a26.439 26.439 0 01-13.473-3.69l-.967-.573-10.02 2.627 2.675-9.765-.63-1.001a26.394 26.394 0 01-4.047-14.083c.006-14.592 11.88-26.462 26.483-26.462 7.071.003 13.717 2.759 18.715 7.76 4.998 5.003 7.749 11.652 7.747 18.723-.007 14.592-11.882 26.464-26.472 26.464z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "whats-app-2_svg__paint0_linear",
    x1: 42.355,
    y1: 68.148,
    x2: 42.355,
    y2: 6.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "whats-app-2_svg__filter0_d",
    x: 0,
    y: 0,
    width: 84.71,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00392157 0 0 0 0 0.556863 0 0 0 0 0.196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
export default SvgWhatsApp2;